var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgLots(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.8571 0H2.14286C1.57471 0.000567296 1.03 0.226514 0.628255 0.628255C0.226514 1.03 0.000567296 1.57471 0 2.14286V27.8571C0.000567296 28.4253 0.226514 28.97 0.628255 29.3717C1.03 29.7735 1.57471 29.9994 2.14286 30H27.8571C28.4253 29.9994 28.97 29.7735 29.3717 29.3717C29.7735 28.97 29.9994 28.4253 30 27.8571V2.14286C29.9994 1.57471 29.7735 1.03 29.3717 0.628255C28.97 0.226514 28.4253 0.000567296 27.8571 0ZM27.8571 12.8571H22.5V2.14286H27.8571V12.8571ZM15 2.14286H20.3571V12.8571H15V2.14286ZM12.8571 2.14286V19.2857H2.14286V2.14286H12.8571ZM2.14286 21.4286H12.8571V27.8571H2.14286V21.4286ZM15 27.8571V15H27.8571V27.8571H15Z",
    fill: "#BEBFC3"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLots);
export default __webpack_public_path__ + "static/media/lots.0d67fa8fdacb10c56943fd1042b08925.svg";
export { ForwardRef as ReactComponent };